import { HttpService } from "./http.service";

const basePath = "/BranchMonitoring";
const request = HttpService.handleRequest();

export const BranchMonitoringService = {
  getByBranchId
};

async function getByBranchId(id) {
  return request.get(`${basePath}/GetByBranchId/${id}`);
}

export default BranchMonitoringService;